var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegularupdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 15455"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 11.1111,
    cy: 38.8885,
    r: 10.8333,
    stroke: "#FF2D20",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56",
    cx: 36.1111,
    cy: 11.1111,
    r: 10.8333,
    stroke: "#0000FF",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57",
    cx: 22.2223,
    cy: 25.0001,
    r: 19.4444,
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58",
    cx: 2.77778,
    cy: 5.55512,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 59",
    cx: 46.6667,
    cy: 38.8891,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 15449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M21.65 28.3766V21.4326L24.2862 24.2755",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M21.65 21.4326L19.0139 24.2755",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.0158 25.872C29.0579 25.5512 29.0805 25.2282 29.0835 24.9047C29.0805 24.5813 29.0579 24.2582 29.0158 23.9375L31.1099 22.298C31.3057 22.1484 31.3578 21.8756 31.2308 21.6644L29.2479 18.2258C29.129 18.0124 28.8697 17.9211 28.6434 18.013L26.172 19.0093C25.6578 18.6168 25.0954 18.2918 24.4986 18.0421L24.1262 15.4159C24.0922 15.1756 23.8853 14.9976 23.6425 15H19.6671C19.4244 14.9977 19.2174 15.1756 19.1835 15.4159L18.811 18.0421C18.2135 18.2902 17.651 18.6154 17.1377 19.0093L14.6566 18.013C14.4303 17.9211 14.1709 18.0124 14.0521 18.2258L12.0692 21.6644C11.9422 21.8756 11.9943 22.1484 12.1901 22.298L14.2794 23.9375C14.2374 24.2583 14.2148 24.5813 14.2117 24.9047C14.2146 25.2282 14.2372 25.5512 14.2794 25.872L12.1901 27.5115C11.9943 27.661 11.9422 27.9339 12.0692 28.145L14.0521 31.5837C14.1709 31.7971 14.4303 31.8884 14.6566 31.7964L17.128 30.8002C17.6422 31.1926 18.2046 31.5177 18.8014 31.7674L19.1738 34.3935C19.2078 34.6339 19.4147 34.8118 19.6574 34.8094H23.6232C23.866 34.8118 24.0729 34.6339 24.1069 34.3935L24.4793 31.7674C25.0768 31.5193 25.6394 31.194 26.1527 30.8002L28.624 31.7964C28.8503 31.8884 29.1097 31.7971 29.2286 31.5837L31.2115 28.145C31.3384 27.9339 31.2863 27.6611 31.0906 27.5115L29.0158 25.872Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularupdates);
export default __webpack_public_path__ + "static/media/Regularupdates.4f74cba42fefc88a62eabc0f136e9797.svg";
export { ForwardRef as ReactComponent };